import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import type { RoomTask } from 'src/common/interfaces/tasks';
import { VirtualEnvironmentSetup } from '../../virtual-environment-setup';
type UseVirtualEnvironmentTemplateProps = {
  placeholder: Element[];
  mode: 'attackbox' | 'target-machine' | 'complete';
  roomCode: string;
  hasSeenVmStart: boolean;
  task: Omit<RoomTask, 'created' | 'deadline' | 'questions'>;
  hasMultipleVMs: boolean;
  contentReady: boolean;
};
export function useVirtualEnvironmentTemplate({
  placeholder,
  mode,
  roomCode,
  hasSeenVmStart,
  task,
  hasMultipleVMs,
  contentReady
}: UseVirtualEnvironmentTemplateProps) {
  const [wrappers, setWrappers] = useState<HTMLDivElement[]>([]);
  useEffect(() => {
    if (!contentReady || !placeholder.length) {
      setWrappers([]);
      return;
    }
    const newWrappers = placeholder.map((element, index) => {
      const wrapper = document.createElement('div');
      wrapper.id = `${mode}-${index}-wrapper`;
      element.innerHTML = '';
      element.appendChild(wrapper);
      return wrapper;
    });
    setWrappers(newWrappers);
    return () => {
      for (const wrapper of newWrappers) {
        wrapper.remove();
      }
    };
  }, [placeholder, mode, contentReady]);
  return wrappers.map(wrapper => createPortal(<VirtualEnvironmentSetup key={wrapper.id} roomCode={roomCode} hasSeenVmStart={hasSeenVmStart} task={task} hasMultipleVMs={hasMultipleVMs} mode={mode} />, wrapper));
}